module.exports = {
    template: '#add-course-form',

    props: {
        isAdding: Boolean
    },

    data: function() {
        return {
            selectedCourse: ''
        }
    },

    methods: {
        courseSelected: function(e) {
            this.$dispatch('course-selected', this.selectedCourse);
            console.log(this.selectedCourse);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./myCourses/addCourseFormComponent.js
// module id = 11
// module chunks = 0